/** Share Response class */
export class ShareResponse {
  /** application Id */
  public applicationId?: number;
  /** Primary Applicant Shares Details */
  public primaryApplicant = new ApplicantProduct();
  /** Co Applicant Shares Details */
  public coApplicant = new ApplicantProduct();
  /** Additional Co Applicant Shares Details */
  public additionalCoApplicant = new ApplicantProduct();
  /** Responsibile Parties 4 */
  public responsibleParties4 = new ApplicantProduct();
  /** Application Status */
  public applicationStatus: string;
  /** Share Options */
  public shareOptions = new APMembershipOptions();
}

/** Applicant Share Details */
export class ApplicantProduct {
  /** applicant Id */
  public applicantId?: number;
  /** firstName */
  public firstName: string;
  /** lastName */
  public lastName: string;
  /** bundle path name */
  public bundlePath: string;
  /** Shares */
  public shares: Product[] = [];
  /** Membership Services */
  public membershipServices: MembershipService[] = [];
}

/** product class */
export class Product {
  /** product Type Id */
  public typeId?: number;
  /** product Type */
  public type: string;
  /** type alias name */
  public typeName: string;
  /** type description */
  public typeDescription?: string;
  /** Required OptIn Type */
  public requiredOptInType?: string;
  /** is included to membership */
  public isIncluded: boolean;
  /** product is checked, used for funding selection */
  public isChecked?: boolean;
  /** product is selected */
  public isSelected?: boolean;
  /** optin */
  public optIn: boolean;
  /** canHaveBeneficiary */
  public canHaveBeneficiary?: boolean;
  /** No of Joint Applicant */
  public numberOfJointApplicants?: number;
  /** share id */
  public id?: number;
  /** share name */
  public name: string;
  /** product description */
  public description?: string;
  /** payment */
  public payment?: ShareFundAccount;
  /** optional services */
  public optionalServices?: {
    /** applicantShareRelatedProductID */
    applicantShareRelatedProductID?: number;
    /** optional service name */
    name: string;
    /** description */
    description: string;
    /** Required OptIn Type */
    requiredOptInType?: string;
    /** optional service is selected */
    isSelected?: boolean;
    /** Available for JOint Owner */
    availableForJointOwner?: boolean;
    /** bundle Index */
    bundleIndex?: number;
    /** Is Visible */
    isVisible?: boolean;
    /** isHidden */
    isHidden: boolean;
  }[];
  /** prouct details */
  public details?: string[];
  /** minimum amount */
  public minimumAmount?: string;
  /** terms included in product */
  public terms?: ProductTerm[];
  /** Sort order */
  public sortOrder?: number;
  /** Tax Year for Retirement Account */
  public taxYear?: string;
  /** Contribution Source for Retirement Account */
  public contributionSource?: string;
  /** application share Id */
  public applicationShareID?: number;
  /** applicant share Id */
  public applicantShareID?: number;
  /** bundle Index */
  public bundleIndex?: number;
  /** Enabled or not */
  public isDisabled = false;
  public shareGroupID: number;
  public shareGroupName: string;
  public coApplicants?: ApplicantProduct[];
  /** isHidden */
  public isHidden?: boolean;
}

/** Product Term Options */
export class ProductTerm {
  /** Term Period From ex- '12 Months / 36 Months' */
  public termPeriodFrom?: number;
  /** Term Period To ex- '24 Months / 48 Months' */
  public termPeriodTo?: number;
  /** Minimum Balance */
  public minBalance: string;
  /** Maximum Balance */
  public maxBalance: string;
  /** Current APY */
  public currentAPY: string;
  /** Current */
  public current: string;
  /** Share Nick Name */
  public shareNickName?: string;
  /** Selected Term in Months */
  public termInMonths?: string;
  /** Selected Dividend Option */
  public dividendOption?: string;
  /** Selected Maturity Option */
  public maturityOption?: string;
  /** Tax Year */
  public taxYear?: string;
  /** Selected Contribution Source */
  public contributionSource?: string;
  /** Selected Contribution Amount */
  public contributionAmount?: string;
  /** Is Selected this term period option */
  public isSelected?: boolean;
  /** bundle Index */
  public bundleIndex?: number;
  /** property use to hide terms dropdown */
  public hideTermInMonth?: boolean;
  /** sort number will be populated based on termperiodfrom to display range first  */
  public sortNumber?: number;
}

/** Standalone Membership Services class */
export class MembershipService {
  /** Applicant Membership Related Prodcut ID */
  applicantMembershipRelatedProductID?: number;
  /** Related Rroduct ID */
  relatedProductId?: number;
  /** Related Product name */
  relatedProductName: string;
  /** Related Product Type Name  */
  relatedProductTypeName: string;
  /** description */
  description: string;
  /** optional service is selected */
  isSelected: boolean;
  /** Available for JOint Owner */
  availableForJointOwner: boolean;
  /** Required OptIn Type */
  requiredOptInType?: string;
  /** isIncluded */
  isIncluded: boolean;
  /** isHidden */
  isHidden: boolean;
  /** bundle Index */
  bundleIndex?: number;
  /** Sort order */
  sortOrder?: number;
}

/** Share Fund Payment */
export class ShareFundAccount {
  /** Bank Payment */
  public bank?: BankPayment;
  /** Card Payment */
  public card?: CardPayment;
  /** Fund Amount */
  public fundAmount?: string;
  /** Transfer Type */
  public transferType?: string;
}

/** Bank Payment */
export class BankPayment {
  /** Account Number */
  public accountNumber?: string;
  /** Routing Number */
  public routingNumber?: string;
}

/** Card Payment */
export class CardPayment {
  /** Card Number */
  public cardNumber?: string;
  /** CVV */
  public ccv?: string;
  /** Expiration Date */
  public expirationDate?: string;
  /** Name */
  public name?: string;
}

export class ShareCertificateTerms {
  public id: number;
  public termOptions: OptionType[] = [];
}

export interface OptionType {
  value: string;
  label: string;
}

export interface AdditionalAccountsCardState {
  isCardSaved?: boolean | null;
  lastSavedState?: boolean | null;
}

/** Share Certificate Term Options */
export interface IAPMembershipOptions {
  dividendOptions: IShareOptionType;
  maturityOptions: IShareOptionType;
}

export class APMembershipOptions implements IAPMembershipOptions {
  /**
   * MembershipOptions object to get admin configuration for dividend and maturity options.
   */
  constructor() {
    this.dividendOptions = new ShareOptionType();
    this.maturityOptions = new ShareOptionType();
  }
  /** Dividend Options */
  dividendOptions: IShareOptionType;
  /** Maturity Options */
  maturityOptions: IShareOptionType;
}
export class ShareOptionType implements IShareOptionType {
  /**
   * Share option type object to fetch and store admin configuration
   */
  constructor() {
    this.pickList = [];
    this.isRequired = true;
    this.isVisible = false;
    this.defaultValue = '';
  }
  /** To set option to hidden or visible  */
  isVisible: boolean;
  /** Is the option required */
  isRequired: boolean;
  /** Sets default value for the option */
  defaultValue: string;
  /** dropdown values for the option */
  pickList: IOaoDropdown[];
}
export interface IShareOptionType {
  isVisible: boolean;
  isRequired: boolean;
  defaultValue: string;
  pickList: IOaoDropdown[];
}

export interface IOaoDropdown {
  value: string;
  id: number;
  label: string;
  isActive: boolean;
}
